<template>
	<div>
		<div class="module_title05">
			<span>近12个月油耗分析：</span>
		</div>
		<div class="ibox-content alarm_info_list" style="height:400px;">
			<div ref="bar" :style="lineStyle"></div>
		</div>
	</div>	
</template>
<script>
//vuex
import {mapState} from 'vuex'
let echarts = require('echarts/dist/echarts.simple.min');
var chart = null
export default {
  	name: 'BarComp',
  	props:['monthInfo'],
  	computed: {
	  	lineStyle:function(){
	  		return {
	  			width:'100%',
	  			height:'100%'
	  		}
	  	},
	  	...mapState({
			currentIndex:state => state.home.currentIndex,
			curSubTab:state=>state.home.curSubTab
		})
	},
	watch:{
	  	currentIndex(val){
	  		if(val.indexOf('file') != -1){
	  			chart.resize()
	  			this.initChart()
	  		}
	  	},
	  	curSubTab(val){
	  		if(val=='detailHome'){
	  			chart.resize()
	  			this.initChart()
	  		}
	  	}
	},
	mounted(){
		 this.initChart() 	
	},
	methods:{
		initChart(){
			chart = echarts.init(this.$refs.bar);
		  	let lineData = [];
		  	let lineTitle = [];
		  	this.monthInfo.forEach(function(item, i) {
		  		lineData.push(item.oil);
		  		lineTitle.push(item.yearMonth)
		  	})
		  	chart.setOption({
		  		color: ['#20B2AA'],
			    tooltip : {
			        trigger: 'axis',
			        axisPointer : {            // 坐标轴指示器，坐标轴触发有效
			            type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        }
			    },
			    grid: {
			        left: '3%',
			        right: '4%',
			        bottom: '3%',
			        containLabel: true
			    },
			    xAxis : [
			        {
			            type : 'category',
			            data : lineTitle,
	//		            data : ["1","2","3","4","5","6","7","8","9","10","11","12"],
			            axisTick: {
			                alignWithLabel: true
			            }
			        }
			    ],
			    yAxis : [
			        {
			            type : 'value'
			        }
			    ],
			    series : [
			        {
			            name:'月油耗',
			            type:'bar',
			            barWidth: '60%',
			            data:lineData,
						label: {
			                normal: {
			                    show: true,
			                    position: 'top',
			                    formatter: '{c}L'
			                }
						},
	//		            data:[10, 52, 200, 334, 390, 330, 220,10, 52, 200, 334,43]
			        }
			    ]
		  	});  	
			$(window).resize(chart.resize);
		}
	}

}

</script>


// WEBPACK FOOTER //
// BarComp.vue?4c6011d4